import { Top5Data } from "../services/insider-buying-top5";

export const getBuyingTop5Options = (data: Top5Data["dropDown"]) =>
  data?.map(({ member, title }) => `${member} (${title})`) ?? [];
